<template>
    <div>
      <a :href="url" target="_blank" v-if="url != ''" class="image-text-card">
        <div class="image-wrapper">
          <BaseImage 
            :src="imageUrl" 
            :alt="alt"
            class="card-image"
          />
        </div>
        <div class="text-wrapper">
          <h3 class="card-title text_bold" :style="{ color: titleColor }">{{ title }}</h3>
          <p class="card-content" :style="{ color: contentColor }">{{ content }}</p>
        </div>
      </a>
      <div v-else>
        <div class="image-wrapper">
          <BaseImage 
            :src="imageUrl" 
            :alt="alt"
            class="card-image"
          />
        </div>
        <div class="text-wrapper">
          <h3 class="card-title text_bold" :style="{ color: titleColor }">{{ title }}</h3>
          <p class="card-content" :style="{ color: contentColor }">{{ content }}</p>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
    import BaseImage from '@/components/common/BaseImage.vue'
  defineProps({
    imageUrl: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    },
    titleColor: {
    type: String,
    default: '#1d1d1f' // Default title color
  },
  contentColor: {
    type: String,
    default: '#6e6e73' // Default content color
  },
  url: {
    type: String,
    default: ''
  },
  alt: {
    type: String,
    default: ''
  } 
  })
  </script>
  
  <style scoped>
  .image-text-card {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
  }
  
  .image-wrapper {
    width: 100%;
    aspect-ratio: 3/4;
    overflow: hidden;
    margin-bottom: 20px;
    border-radius: 30px;
    background-color: #00000010;
    margin: 0 0 20px 0;
  }

  .image-wrapper :deep(.base-image-container) {
    width: 100%;
    height: 100%;
  }
  
  .image-wrapper :deep(.base-image) {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }
  
  .image-text-card:hover .image-wrapper :deep(.base-image) {
    transform: scale(1.05);
  }
  
  .text-wrapper {
    width: 100%;
    padding: 0 15px;
  }
  
  .card-title {
    font-size: 24px;
    font-weight: bold;
    color: #1d1d1f;
    margin-bottom: 10px;

  }
  
  .card-content {
    font-size: 16px;
    color: #6e6e73;
  }
  
  @media screen and (max-width: 768px) {
    .card-title {
        font-size: clamp(1.3rem, 2vw, 1.5rem);
    }
  
    .card-content {
        font-size: clamp(0.8rem, 1vw, 1rem);
    }
   

  }
  </style>